import { useReveal } from '../hooks/useReveal'

/**
 * Wraps children in a scroll-reveal container. `as` lets callers choose the
 * element tag; `delay` staggers grouped items (e.g. grids of cards).
 */
export default function Reveal({
  children,
  as: Tag = 'div',
  delay = 0,
  className = '',
  ...rest
}) {
  const { ref, isVisible } = useReveal()

  return (
    <Tag
      ref={ref}
      className={`reveal ${isVisible ? 'is-visible' : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  )
}
